export default "__VITE_ASSET__BeLifrQ___"